import { FlexGrid2, TypographyBody } from '@honeycomb/ui-core';
import React from 'react';
export function RoomPickerPanel({ title, subTitle, children, fieldId }) {
    return (React.createElement(FlexGrid2, { container: true, flexWrap: "nowrap" },
        React.createElement(FlexGrid2, { xs: "fill" },
            React.createElement(TypographyBody, { size: "s", component: "label", weight: "semiBold", htmlFor: fieldId }, title),
            React.createElement(TypographyBody, { size: "s", component: "div", color: "text.light" }, subTitle)),
        React.createElement(FlexGrid2, { xs: "hold" }, children)));
}
